import { useState,useEffect } from "react";
import {
  Box,
} from "@chakra-ui/react";
// import { FaUserAlt, FaLock } from "react-icons/fa";
import RingLoader from "react-spinners/RingLoader";
import AuthService from '../../services/auth.service'
import { useHistory } from "react-router-dom";
// const CFaUserAlt = chakra(FaUserAlt);
// const CFaLock = chakra(FaLock);

const LoginSSO = (props) => {
  const [isLoading, setisLoading] = useState(false);
  // const toast = useToast();
  const history = useHistory();
  useEffect(() => {
    setisLoading(true);
    AuthService.login().then(
      () => {
        history.push("/statistics");
      },
      error => {
        
        /*const resMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();

        toast({
          title: result.error,
          position: "top",
          status: "error",
          isClosable: true,
        });*/
      }
    );    
  }); // Only re-run the effect if count changes
  return (
    <>
        <Box className={isLoading?'lodder-display' : 'lodder-disable'}>
            <RingLoader color="#5e5e72" loading={isLoading}  size={50} />
        </Box>
    </>
  );
};

export default LoginSSO;
